import type { FormkitComponent } from "./components";
import type { FormkitModifier } from "./modifiers";
import type { BaseFormkitNode, FormkitNode, NodeType } from "./nodes";

export type BaseFormkitLayout = BaseFormkitNode & {
  type: NodeType.Layout;
  layout: LayoutType;
  children: FormkitNode[];
};

export enum LayoutType {
  Form = "form",
  Section = "section",
  Accordion = "accordion",
}

type BaseFormkitSection = BaseFormkitLayout & {
  /**
   heading and subheading support liquid templated strings with access to context.
   */
  heading?: string;
  subheading?: string;
  optional?: boolean;
  parent?: boolean;
  size?: "small" | "large";
  component?: FormkitModifier | FormkitComponent;
};

export type StandardFormkitSection = BaseFormkitSection & {
  layout: LayoutType.Section;
};

export type AccordionFormkitSection = BaseFormkitSection & {
  layout: LayoutType.Accordion;
};

export type FormkitSection = StandardFormkitSection | AccordionFormkitSection;

export type FormkitForm = BaseFormkitLayout & {
  layout: LayoutType.Form;
  // Optional array of key-key edges that should not be topographically
  // sorted before resolving (Yup-specific thing that you should avoid using
  // unless you see "cyclic dependency errors")
  noSortEdges?: [string, string][];
};

export type FormkitLayout = FormkitSection | FormkitForm;
